module.exports = __webpack_public_path__ + "img/MapPicsCoastal.b8dcdc42.webp";